import { render, staticRenderFns } from "./ImagePreviewPage.vue?vue&type=template&id=40706178"
import script from "./ImagePreviewPage.vue?vue&type=script&lang=js"
export * from "./ImagePreviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports